import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $textColor?: string;
}

export const FilterChipBtn = styled.div<IProps>`
  ${mixin.flex({ display: 'inline-flex', justify: 'flex-start' })};
  height: 32px;
  border-radius: 2px;
  border: 1px solid #eee;

  .btn {
    height: inherit;
    padding: 7px 12px;
  }

  .text {
    line-height: 130%;
    font-size: 14px;
    font-weight: ${({ $textColor }) => ($textColor ? 600 : 400)};
    color: #555;
  }

  .area-logo {
    ${mixin.flex({ display: 'inline-flex' })};

    /* 로고는 올라온 이미지 크기를 그대로 쓴다(가로·세로 모두 알 수 없다).
       칩을 밀어낼 만큼 큰 이미지만 max-height로 막고, 그때도 비율은 유지된다 */
    &.type-image .img {
      width: auto;
      height: auto;
      max-height: 20px;
    }
  }

  ${({ $textColor }) =>
    $textColor &&
    css`
      .text {
        color: ${$textColor};
      }
    `}

  &.active {
    border-color: #000;
    background-color: #000;

    .text {
      color: #fff;
      font-weight: 600;
    }
  }

  .btn.disabled {
    opacity: 0.4;
  }

  @media ${({ theme }) => theme.media.smMax} {
    height: ${mixin.pxToVw('32')};
    border-radius: ${mixin.pxToVw('2')};

    .btn {
      padding: ${mixin.pxToVw('7 12')};
    }

    .text {
      font-size: ${mixin.pxToVw('14')};
    }

    .area-logo.type-image .img {
      max-height: ${mixin.pxToVw('20')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    height: 37px;

    .btn {
      padding: 8px 16px;
    }

    .text {
      font-size: 16px;
    }

    .text,
    &.active .text {
      font-weight: ${({ $textColor }) => ($textColor ? 600 : 400)};
    }

    .area-logo.type-image .img {
      max-height: 24px;
    }

    /* W.Only 로고는 PC에서만 on/off 크기가 다르다 */
    .btn[aria-label='W.Only'] .area-logo svg {
      width: 49px;
      height: auto;
    }
  }
`;
